// SS-1381: temporary V1/V2 split for demos. Remove with the V1 sunset.
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import {
  readAdminUiVersion,
  storeAdminUiVersion,
  V1_UI_VERSION,
  V2_UI_VERSION,
} from '@/lib/adminUiVersion';

import { useConfirmation } from '@/providers';

type Props = {
  companyId: number;
};

export const UiVersionToggle = (props: Props) => {
  const { companyId } = props;
  const { t } = useTranslation();
  const { confirm } = useConfirmation();
  const currentVersion = readAdminUiVersion();
  const nextVersion =
    currentVersion === V1_UI_VERSION ? V2_UI_VERSION : V1_UI_VERSION;

  const onVersionSwitch = () => {
    confirm({
      title: t('Interface version'),
      description:
        nextVersion === V2_UI_VERSION
          ? t('Switch to V2? The interface will reload.')
          : t('Switch to V1? The interface will reload.'),
      confirmLabel: t('Switch'),
      onConfirm: () => {
        storeAdminUiVersion(nextVersion);

        if (!companyId) {
          window.location.reload();
          return;
        }

        window.location.href = `/companies/${companyId}/clients`;
      },
    });
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="text-foreground h-7 px-2 text-xs font-semibold"
      onClick={onVersionSwitch}
    >
      {currentVersion.toUpperCase()}
    </Button>
  );
};
